import React from 'react';
import UFOLoadHold from '@atlaskit/react-ufo/load-hold';
import { ContentWrapper } from '@atlassian/jira-spa-apps-common/src/skeletons/index.tsx';
import {
	SkeletonFilter,
	SkeletonHeading,
} from '@atlassian/jira-spa-apps-common/src/skeletons/main.tsx';

export const Skeleton = (): React.JSX.Element => (
	<UFOLoadHold name="project-versions-skeleton">
		{/* @ts-expect-error - TS2741 - Property 'marginRight' is missing in type '{ children: Element[]; }' but required in type 'Readonly<ThemedOuterStyledProps<ClassAttributes<HTMLDivElement> & HTMLAttributes<HTMLDivElement> & { marginRight: string | number; }, any>>'. */}
		<ContentWrapper>
			<SkeletonHeading />
			<SkeletonFilter avatar={false} />
		</ContentWrapper>
	</UFOLoadHold>
);
